import React from "react";
import PropTypes from "prop-types";
import { Button, Empty, } from "antd";

export default class ErrorBoundary extends React.Component {
  state = {
    error: '',
    errorInfo: '',
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.log({ error, errorInfo });
    this.setState({ errorInfo });
  }

  render() {
    // next code block goes here
    // return this.props.children;
    const { hasError, errorInfo } = this.state;
    if (hasError) {
      return (
        <div className="gx-app-login-wrap">

          <Empty
            image={<img src={`${process.env.PUBLIC_URL}/something-wrong.png`} />}
            imageStyle={{
              height: '50vh',
            }}
            style={{
              backgroundColor: 'transparent',
            }}
            description={
              <span>
                Something went wrong!
              </span>
            }>
            <Button type="primary" onClick={() => {
              // console.log('Reloading ...');
              window.location.reload();
              // return <Redirect to={'/dashboard'}/>
            }}>Retry</Button>
          </Empty>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
